import { useMemo } from "react";
import SubscriptionSummary from "./SubscriptionSummary";

export default function SubscriptionCard({
  plan,
  setPlan,
  autoRenew,
  setAutoRenew,
  connections,
  addons,
}) {
  const combinedItems = useMemo(() => {
    return [
      ...connections.map((item) => ({ ...item, type: "connection" })),
      ...addons.map((item) => ({ ...item, type: "addon" })),
    ];
  }, [connections, addons]);

  return (
    <div className="w-full bg-white shadow-lg rounded-2xl p-6 mb-6">
      <div className="flex justify-between items-center mb-4">
        <div>
          <h2 className="text-lg font-semibold">Subscription</h2>
          <p className="text-gray-500">Current Plan: {plan} Plan</p>
        </div>
        <span className="px-3 py-1 rounded-full text-sm bg-indigo-100 text-indigo-700 font-medium">
          {plan} Plan
        </span>
      </div>

      {/* Plan Actions */}
      <div className="flex flex-wrap gap-3 mb-6">
        <button
          onClick={() => setPlan("Pro")}
          className="px-4 py-2 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 transition"
        >
          Upgrade to Pro
        </button>
        <button
          onClick={() => setPlan("Basic")}
          className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
        >
          Downgrade to Basic
        </button>
        <button className="px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 transition">
          Cancel
        </button>
      </div>

      {/* Billing Info */}
      {plan.toLowerCase() !== "basic" ? (
        <div>
          <div className="bg-gray-100 rounded-xl p-4 mb-6">
            <h3 className="font-medium">Billing Information</h3>
            <p className="text-sm text-gray-600">Renews on: Oct 10, 2025</p>
            <p className="text-sm text-gray-600">
              Payment: **** **** **** 4242
            </p>
          </div>
          <div className="flex items-center justify-between bg-gray-100 rounded-xl p-4">
            <span className="text-sm font-medium">Auto-Renew</span>
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={autoRenew}
                onChange={() => setAutoRenew(!autoRenew)}
                className="sr-only peer"
              />
              <div className="w-11 h-6 bg-gray-300 rounded-full peer peer-checked:bg-indigo-600 transition"></div>
              <div className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full shadow-md transform peer-checked:translate-x-5 transition"></div>
            </label>
          </div>
        </div>
      ) : (
        <div className="w-full mt-12 p-6 bg-white rounded-2xl shadow-md text-center">
          <p className="text-gray-600 mb-4">
            We do not currently hold a payment method for your account. Add a
            payment method to unlock access to premium connections and addons.
          </p>
          <button className="px-5 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition">
            Add Payment Method
          </button>
        </div>
      )}
      <SubscriptionSummary
        plan={plan}
        combinedItems={combinedItems as []}
        // onAddToSubscription={() => {
        //   console.log("ADD TO SUBSCRIPTION");
        // }}
      />
    </div>
  );
}
